export const selectInvoiceCheckout = state =>
    state.views.invoiceCheckout.invoice;

export const selectInvoicePayment = state =>
    state.views.invoiceCheckout.payment;

export const selectInvoiceOngoingPayment = state =>
    state.views.invoiceCheckout.ongoingPaymentAttempt;

export const selectCheckoutSummary = state =>
    state.views.invoiceCheckout.checkoutSummary;

export const selectSellerPhoneNumber = state =>
    state.views.invoiceCheckout.sellerPhoneNumber;
